import { render, staticRenderFns } from "./ProviderBalance.vue?vue&type=template&id=32bac503&"
import script from "./ProviderBalance.vue?vue&type=script&lang=js&"
export * from "./ProviderBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports